import { makeEntityScaffold } from '@classpass/saga-tools';

import URLS from 'constants/urls';
import { transformV2ClientResponse } from 'helpers/core';
import { VENUE_FEATURE_PROBE_HTTP_CONFIG } from 'helpers/session-auth-http';

// A 401/403 here means this venue/user lacks Calendar Sync access, not an expired
// session — surface it via the in-flow error UI instead of redirecting to login.
const handler = ({ httpClient }, venueId) => {
  const endpoint = URLS.venue.googleCalendarsList(venueId);

  return httpClient.get(endpoint, VENUE_FEATURE_PROBE_HTTP_CONFIG).then(transformV2ClientResponse);
};

export default makeEntityScaffold('SAGA.API.VENUE_GOOGLE_CALENDARS', handler, { defaultKey: 1 });
